import React from 'react'
import Avatar from 'material-ui/Avatar'


const UserAvatar = (props)=>{
  let {uid=''} = props
  let id = uid.split(':')[1] || uid
  let uri = `https://graph.facebook.com/${id}/picture?width=128&height=128`
  return <Avatar src={uri} {...props}/>
}

export default UserAvatar


/** WEBPACK FOOTER **
 ** ./src/app/components/UserAvatar.js
 **/